import get from 'lodash-es/get';

export function graphqlErrors(error: any, property = 'message') {
    return get(error, ['graphQLErrors', '0', property], null);
}
